module.exports = "//static.hsappstatic.net/FileManagerImages/static-1.6823/images/no-results.svg"